export const CUSTOM_ICONS = [
  {
    svg: 'history-icon',
    path: 'assets/icons/menu/history.svg',
  },
  { svg: 'info-icon', path: 'assets/icons/menu/info.svg' },
  { svg: 'play-icon', path: 'assets/icons/menu/play.svg' },
  {
    svg: 'trophy-icon',
    path: 'assets/icons/menu/trophy.svg',
  },
];
